import { FormValidations } from "features/shared/forms/hooks/useForm";
import ValidationRule from "features/validation/rules/ValidationRule";

export const accountRoleValidations = (): FormValidations => {
  return {
    role: {
      required: true,
      type: "OnlyRequired",
    } as ValidationRule
  };
}